
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'formalcostorderIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'formalcostorder',
				windowName: '形式费用单',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig,columns,gridOptions){	
				gridOptions.checkboxConfig = null
				columns.forEach((item)=>{
					if(item.field=='reslut'){
						item.slots = {
							default:(params)=>{
								return <div>
											<i style="margin-right:6px;cursor: pointer;font-size:14px" onClick={()=>{this.getStatus(params.row)}} class="el-icon-refresh-left"></i>
											<span>{params.row.reslut?params.row.reslut:''}</span>
										</div>
							}
						}
					}
					if(item.field=='jindietype'){
						item.slots = {
							default: ({row,column}) => {	
								let str= []
								if(row.jindierequire){
									let buff = this.checkjindierequire(row)
									if(buff){
										str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">星</el-tag>)
									}else{
										str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">星</el-tag>)
									}
									
								}
								str.push(<span>{column.formatter({row:row})}</span>)
								return str
							}
						}
					}
				})
			},
			checkjindierequire(row){
				let data = row.jindierequire
				let buff = true
				if(!data.costorder_detail.length){
					buff = false
				}
				data.costorder_detail.forEach((item)=>{
					if(!item.FPURPOSEID_FNumber || !item.FSETTLETYPEID_FNumber){
						buff = false
					}
				})
				if(!data.main.FACCOUNTID_FNumber || !data.main.FCONTACTUNITTYPE || !data.main.FCONTACTUNIT_FNumber){
					buff = false
				}
				
				return buff
			},
		},
		components: {
			
		}
	}
</script>
